/** @format */

import React from "react";
import { Form } from "react-bootstrap";

function OrganizationNameSelect({
  orgNameSelect,
  setActivityModal,
  inventory,
  setSelectFromInventory,
  activityModal,
}) {
  const findDiversity = (option) =>
    inventory.inventoryData.find(
      (record) => record.site_name.toLowerCase() === option.toLowerCase()
    );
  return (
    <Form.Group className="mb-3">
      <Form.Label>
        Organization<span className="text-danger">*</span>
      </Form.Label>
      <Form.Select
        ref={orgNameSelect}
        className="form-control"
        required
        name="type"
        value={activityModal.organizationName || ""}
        onChange={(e) => {
          const diversity = findDiversity(e.target.value);
          setActivityModal({
            ...activityModal,
            organizationName: e.target.value,
            diversityCategories: diversity.ans,
            location: `${diversity.City}, ${diversity.State}`,
          });
        }}
      >
        <option value="" disabled>Select Organization</option>
        {inventory.inventoryData.map((option, i) => (
          <option key={i} value={option.site_name} data={option.ans}>
            {option.site_name}
          </option>
        ))}
      </Form.Select>
      <button
        className="btn btn-link p-0 mt-1"
        onClick={() => setSelectFromInventory(false)}
      >
        Enter Organization Name
      </button>
    </Form.Group>
  );
}

export default OrganizationNameSelect;